import { Scale } from "../../utils/Scale"

export class CampPos {

    static startX = () => Scale.width() * 0.038
    static startY = () => Scale.height() * 0.913

    static stopX = () => Scale.width() * 0.74
    static stopY = () => Scale.height() * 0.027

    static roundX = () => Scale.width() * 0.88
    static roundY = () => Scale.height() * 0.945

    static lakeX = () => Scale.width() * 0.039
    static lakeY = () => Scale.height() * 0.31

    static lakeLabelX = () => Scale.width() * 0.15
    static lakeLabelY = () => Scale.height() * 0.53

    static picnicX = () => Scale.width() * 0.061
    static picnicY = () => Scale.height() * 0.01

    static picnicLabelX = () => Scale.width() * 0.166
    static picnicLabelY = () => Scale.height() * 0.082

    static trailLabelX = () => Scale.width() * 0.535
    static trailLabelY = () => Scale.height() * 0.126

    static horsesLabelX = () => Scale.width() * 0.76
    static horsesLabelY = () => Scale.height() * 0.65

    static longLoopLabelX = () => Scale.width() * 0.73
    static longLoopLabelY = () => Scale.height() * 0.76

    static shortLoopLabelX = () => Scale.width() * 0.9
    static shortLoopLabelY = () => Scale.height() * 0.7

    static lodgeX = () => Scale.width() * 0.823
    static lodgeY = () => Scale.height() * 0.146

    static lodgeLabelX = () => Scale.width() * 0.831
    static lodgeLabelY = () => Scale.height() * 0.295

    static decksPlaceholderX = () => Scale.width() * 0.26
    static decksPlaceholderY = () => Scale.height() * 0.29

    static deckX = () => Scale.width() * 0.26
    static deckTopY = () => Scale.height() * 0.195
    static deckBottomY = () => Scale.height() * 0.535

    static pickCardX = () => Scale.width() * 0.365
    static pickCardY = () => Scale.height() * 0.943

    static pawnX = () => Scale.width() * 0.026
    static pawnY = () => Scale.height() * -0.01
    static pawnRound2Y = () => 0

    static userPawnX = () => 0
    static userPawnRound2Y = () => Scale.height() * 0.11

    static busX = () => Scale.width() * 0.12
    static busY = () => Scale.height() * 0.76

    static busLabelX = () => Scale.width() * 0.169
    static busLabelY = () => Scale.height() * 0.85

    static fireworksX = () => Scale.width() * 0.85
    static fireworksY = () => Scale.height() * 0.02

    static panelX = () => Scale.width() * 0.1
    static panelY = () => Scale.height() * 0.1
    static panelWidth = () => Scale.width() * 0.8
    static panelHeight = () => Scale.height() * 0.8

}
